module.exports = __webpack_public_path__ + "img/zl-fx.748112da.svg";